import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ZonesSection = () => {
  const zones = [
    'Eixample',
    'Gràcia',
    'Sants-Montjuïc',
    'Sarrià-Sant Gervasi',
    'Les Corts',
    'Horta-Guinardó',
    'Nou Barris',
    'Sant Andreu',
    'Sant Martí',
    'Ciutat Vella',
    "L'Hospitalet",
    'Badalona',
    'Santa Coloma',
    'Cornellà',
    'El Prat',
    'Sant Cugat',
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-bold text-navy mb-5">
                Cobertura en toda Barcelona
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                Ofrecemos nuestros servicios de vaciado en Barcelona ciudad y toda el área metropolitana. Trabajamos en todos los barrios y municipios cercanos con la misma profesionalidad y rapidez.
              </p>

              <div className="grid grid-cols-2 gap-3 mb-10">
                {zones.map((zone, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <i className="ri-map-pin-fill text-orange text-base"></i>
                    <span className="text-sm text-gray-700">{zone}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/contacto"
                className="inline-block bg-orange text-white px-8 py-4 rounded-full font-medium hover:bg-orange-light hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                Consultar tu zona
              </Link>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
          >
            <div className="rounded-3xl overflow-hidden border border-gray-200 shadow-lg h-[480px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95777.49789922833!2d2.0527731!3d41.3873974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a49816718e30e5%3A0x44b0fb3d4f47660a!2sBarcelona!5e0!3m2!1ses!2ses!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa de cobertura Barcelona"
              ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ZonesSection;
